// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { type AskPunttReviewComment } from "@mg/schemas/src/christo/askPunttReview";
import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { forwardRef, useMemo } from "react";

import { buildCommentNumberById } from "./reviewCommentDisplay";

import {
  AssetViewerPane,
  type AssetFile,
  type AssetViewerPaneHandle,
} from "../../routes/ask-puntt/components/AssetViewerPane";

type AskPunttArtworkViewerProps = {
  reviewId: string;
  title: string;
  files: AssetFile[];
  comments: readonly AskPunttReviewComment[];
  activeCommentId?: string | null;
  onHeaderControlsChange?: (controls: React.ReactNode | null) => void;
  onCommentClick?: (comment: AskPunttReviewComment) => void;
  onArtworkBackgroundClick?: () => void;
};

export const AskPunttArtworkViewer = forwardRef<
  AssetViewerPaneHandle,
  AskPunttArtworkViewerProps
>(function AskPunttArtworkViewer(
  {
    reviewId,
    title,
    files,
    comments,
    activeCommentId = null,
    onHeaderControlsChange,
    onCommentClick,
    onArtworkBackgroundClick,
  },
  ref,
) {
  const stableComments = useMemo(
    () =>
      comments.filter((comment) => !comment.isDeleted) as BaseTicketComment[],
    [comments],
  );
  const commentNumberById = useMemo(
    () => buildCommentNumberById(comments),
    [comments],
  );

  const handleCommentClick = onCommentClick
    ? (comment: BaseTicketComment) =>
        onCommentClick(comment as AskPunttReviewComment)
    : undefined;

  return (
    <AssetViewerPane
      key={reviewId}
      ref={ref}
      title={title}
      assets={files}
      comments={stableComments}
      allReviewComments={stableComments}
      activeCommentId={activeCommentId}
      onCommentClick={handleCommentClick}
      onPinClick={handleCommentClick}
      onArtworkBackgroundClick={onArtworkBackgroundClick}
      commentNumberById={commentNumberById}
      hideCommentPanel
      hideTitleRow
      viewerToolbarPlacement="external"
      viewerContentInset="inset16"
      onHeaderControlsChange={onHeaderControlsChange}
    />
  );
});
